//import axios from 'axios'
import store from '../../store'
// import * as SRSFunc from './SRSFunctions'; 2025-08-13 jazz
import { SRSDefaults } from './SRSFunctions';

export class Gaibu{
    #Url;
    #axios;
    #UserGaibuListItems;
    #MasterGaibuListItems;
  
    constructor (url, axios) {
        this.#Url = url;
        this.#axios = axios;
        this.#UserGaibuListItems    = store.state.UserInterface.GaibuList;
    }

    //********** GETTERS **********
    get UserGaibuListItems(){
        return this.#UserGaibuListItems;
    }

    async getMasterItems(){
        //let gaibuItems = await SRSFunc.SRSDefaults.filteredItems((await axios.get(this.#Url)).data)
        
        const houseTypes = store.state.Master.HouseTypes;
        const selectedHouseType = houseTypes.find(item => item.HouseType == store.state.PlanInfo.HouseType);
        const typeCd = selectedHouseType?.TYPE_CD || null;

        // let gaibuItems = await SRSFunc.SRSDefaults.filteredItems((await axios.get(this.#Url.replace("###", typeCd))).data) 2025-08-13 jazz
        let gaibuItems = await SRSDefaults.filteredItems((await this.#axios.get(this.#Url.replace("###", typeCd))).data)

        return gaibuItems;
    }
 
    ImportMasterDataToStore = async () =>{
        try{
            const response  = await this.#axios.get(this.#Url)

            //store.dispatch('GaibuList', response.data)
        }catch(e){
            console.log(e)
        }
    }

    ImportUserDataToStore = async (progressBar = null, gaibuItems = null) =>{
        if(progressBar){
            await progressBar.increment()
        }

        if(!gaibuItems){
            const houseTypes = store.state.Master.HouseTypes;
            const selectedHouseType = houseTypes.find(item => item.HouseType == store.state.PlanInfo.HouseType);
            const typeCd = selectedHouseType?.TYPE_CD || null;

            // gaibuItems = await SRSFunc.SRSDefaults.filteredItems((await axios.get(this.#Url.replace("###", typeCd))).data) 2025-08-13 jazz
            gaibuItems = await SRSDefaults.filteredItems((await this.#axios.get(this.#Url.replace("###", typeCd))).data)
        }

        if(progressBar){
            await progressBar.increment()
        }

        try{
            // await SRSFunc.SRSDefaults.filteredUserInterface(gaibuItems, 'UserGaibuList') 2025-08-13 jazz
            await SRSDefaults.filteredUserInterface(gaibuItems, 'UserGaibuList')

            if(progressBar){
                await progressBar.increment()
            }
        }finally{
            gaibuItems = null
        }
    }
}